/**
 * Shared Currency Constants
 *
 * Default currency is USD, configurable at the organization level via
 * OrganizationConfig.defaultCurrency. Per-vendor overrides are stored
 * in Company.metadata.defaultCurrency.
 *
 * TODO: Future refactoring needed for:
 * - Multi-currency support per vendor
 * - Currency conversion rate history
 * - Proper currency management system
 * - Per-invoice currency vs vendor default currency
 *
 * @see backend/src/db/models/companies/Company.model.ts - Company.metadata.defaultCurrency
 * @see frontend/src/pages/authenticated/core/spreadsheets/ManualRebateCSVUpload.tsx
 * @see frontend/src/pages/authenticated/core/spreadsheets/ConvertDataPageWorkflow.tsx
 */

/**
 * Supported currency codes
 */
export const CURRENCY_CODES = {
  CAD: "CAD",
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
} as const;

/**
 * Type for currency codes
 */
export type CurrencyCode = (typeof CURRENCY_CODES)[keyof typeof CURRENCY_CODES];

/**
 * Array of currency code values for dropdowns/selectors
 */
export const CURRENCY_CODE_VALUES = Object.values(CURRENCY_CODES);

/**
 * Default currency code (fallback when no org-level default is configured)
 */
export const DEFAULT_CURRENCY_CODE: CurrencyCode = CURRENCY_CODES.USD;
